import React from 'react';
import * as Styled from './ToogleStyles';
import { TooglePropsInterface } from './ToogleTypes';

function Toogle({ isShow, children }: TooglePropsInterface) {
  return <Styled.Container isShow={isShow}>{children}</Styled.Container>;
}

export default Toogle;
